import React from 'react';
import { Link } from 'react-router-dom';
import { GraduationCap, Briefcase, MapPin, ArrowRight } from 'lucide-react';
import { about, site } from '../mock';

const About = () => (
  <div className="fade-in">
    <section className="hero-gradient border-b border-slate-200">
      <div className="max-w-6xl mx-auto px-6 py-20 md:py-28">
        <div className="text-[12px] uppercase tracking-[0.18em] text-[#1F3864] mb-5">About The Garlick Group</div>
        <h1 className="font-serif-display text-4xl md:text-5xl leading-tight text-[#1F3864] max-w-4xl">{about.hero}</h1>
      </div>
    </section>

    <section className="py-20">
      <div className="max-w-3xl mx-auto px-6 space-y-6 text-[17px] leading-[1.8] text-slate-700">
        {about.intro.map((p) => <p key={p.slice(0, 40)}>{p}</p>)}
      </div>
    </section>

    <section className="bg-slate-50 border-y border-slate-200/70 py-20">
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-14">
        <div>
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 bg-[#1F3864] text-white flex items-center justify-center rounded-sm"><GraduationCap size={18} strokeWidth={1.6} /></div>
            <h2 className="font-serif-display text-2xl text-[#1F3864]">Professional Credentials</h2>
          </div>
          <ul className="space-y-3">
            {about.credentials.map(c => (
              <li key={c} className="flex items-start gap-3 text-[15.5px] text-slate-700">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#2E75B6] flex-shrink-0" />
                <span>{c}</span>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 bg-[#1F3864] text-white flex items-center justify-center rounded-sm"><Briefcase size={18} strokeWidth={1.6} /></div>
            <h2 className="font-serif-display text-2xl text-[#1F3864]">Executive Career</h2>
          </div>
          <ul className="space-y-5">
            {about.career.map((c) => (
              <li key={`${c.role}-${c.org}`} className="border-l-2 border-[#1F3864]/20 pl-4">
                <div className="text-[15.5px] font-medium text-[#1F3864]">{c.role}</div>
                <div className="text-[14px] text-slate-600 mt-0.5">{c.org}{c.years ? ` • ${c.years}` : ''}</div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>

    <section className="py-24">
      <div className="max-w-3xl mx-auto px-6">
        <div className="rule-navy mb-6" />
        <h2 className="font-serif-display text-3xl md:text-4xl text-[#1F3864] mb-8">{about.whyHeading}</h2>
        <div className="space-y-6 text-[17px] leading-[1.8] text-slate-700">
          {about.why.map((p) => <p key={p.slice(0, 40)}>{p}</p>)}
        </div>
      </div>
    </section>

    <section className="bg-[#1F3864] text-white">
      <div className="max-w-5xl mx-auto px-6 py-16 md:py-20 grid md:grid-cols-5 gap-10 items-center">
        <div className="md:col-span-3">
          <div className="flex items-center gap-2 text-[12px] uppercase tracking-[0.18em] text-white/70 mb-4"><MapPin size={14} /> Personal Note</div>
          <p className="font-serif-display text-2xl md:text-[28px] leading-snug">{about.personal}</p>
        </div>
        <div className="md:col-span-2">
          <Link to="/contact" className="inline-flex items-center gap-2 bg-white text-[#1F3864] text-[15px] font-medium px-6 py-3.5 rounded-sm hover:bg-slate-100 transition-colors">
            Request a Consultation <ArrowRight size={16} />
          </Link>
          <div className="mt-5 text-[14px] text-white/80">
            <a href={`mailto:${site.email}`} className="hover:text-white">{site.email}</a><br />
            <a href={site.phoneHref} className="hover:text-white">{site.phone}</a>
          </div>
        </div>
      </div>
    </section>
  </div>
);

export default About;
